<template>
  <div>
    <list
      row-key="InvoiceTypeId"
      ref="list"
      unit="发票类型"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="false"
      :get-data-func="api.list"
      urlHash="basedata/finance/invoice"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot> 
      </template>
      <template slot="table">
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/basedata/finance/invoice/list.json";
import tableParam from "@/data/basedata/finance/invoice/query.json";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ba/invoiceType").default,
      params: {
        InvoiceTypeName: "",
        Status: null,
      },
    
    };
  },
  methods: {

    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(this.params).then(() => {
        loading.close();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>